import { ExternalLink, Copy } from "lucide-react";
import { toast } from "sonner";

const BASE = process.env.REACT_APP_BACKEND_URL;
const link = "text-[var(--r2-cyan)] hover:underline flex items-center gap-0.5";

export const RippDexKit = ({ kit, mint }) => {
  if (!kit) return null;
  const copy = (t, label) => navigator.clipboard.writeText(t).then(() => toast(`${label} copied`)).catch(() => toast("copy failed"));
  return (
    <div className="flex flex-wrap items-center gap-2 text-[8px] font-mono" data-testid="ripp-dex-kit">
      <span className="font-bold tracking-[0.14em] text-[var(--r2-amber)]">DEXSCREENER KIT</span>
      <a href={kit.order_url} target="_blank" rel="noreferrer" className={link} data-testid="ripp-dex-order">submit & pay <ExternalLink size={9} /></a>
      <a href={`${BASE}${kit.icon}`} target="_blank" rel="noreferrer" className={link} data-testid="ripp-dex-icon">icon</a>
      <a href={`${BASE}${kit.header}`} target="_blank" rel="noreferrer" className={link} data-testid="ripp-dex-header">header</a>
      <button onClick={() => copy(kit.description, "Description")} className={link} data-testid="ripp-dex-copy-desc"><Copy size={9} /> description</button>
      {mint && <button onClick={() => copy(mint, "CA")} className={link} data-testid="ripp-dex-copy-ca"><Copy size={9} /> CA</button>}
      <span className="text-[var(--r2-text2)]">{kit.links.website} · {kit.links.x}</span>
    </div>
  );
};
